/**
 * @generated SignedSource<<e17763b8b6135348c553966567ad896b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserBalance_target$data = {
  readonly panelistCost: {
    readonly subUnitAmount: number;
  };
  readonly redemptionAmount: {
    readonly formatted: string;
  };
  readonly " $fragmentType": "UserBalance_target";
};
export type UserBalance_target$key = {
  readonly " $data"?: UserBalance_target$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserBalance_target">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserBalance_target",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CurrencyAmount",
      "kind": "LinkedField",
      "name": "panelistCost",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subUnitAmount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CurrencyAmount",
      "kind": "LinkedField",
      "name": "redemptionAmount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "formatted",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AmountDenomination",
  "abstractKey": null
};

(node as any).hash = "5df540b7db946f87f6e1dd036483af90";

export default node;
